export const PAYRUN_EVENTS_LOAD = 'PAYRUN_EVENTS_LOAD'
export const PAYRUN_EVENTS_LOAD_PENDING = 'PAYRUN_EVENTS_LOAD_PENDING'
export const PAYRUN_EVENTS_LOAD_FULFILLED = 'PAYRUN_EVENTS_LOAD_FULFILLED'
export const PAYRUN_EVENTS_LOAD_REJECTED = 'PAYRUN_EVENTS_LOAD_REJECTED'
